import { Component, HostBinding, Input } from '@angular/core';
import { IconType } from '../../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-button-input',
  templateUrl: './button-input.component.html',
  standalone: false,
})
export class ButtonInputComponent {
  @HostBinding('class') get hostClasses() {
    return this.class;
  }

  @Input() class: string = '';
  @Input() title: string = '';
  @Input() color: string = '';
  @Input() text: string | undefined;
  @Input() icon: IconType | string | undefined;
  @Input() click!: () => void;
  @Input() mouseover!: () => void;

  btnClick() {
    if (this.click) {
      this.click();
    }
  }

  btnMouseOver() {
    if (this.mouseover) {
      this.mouseover();
    }
  }
}
